import PropTypes from 'prop-types';
import React from 'react';
import { env } from 'src/config/env';

const ViewVerbalConsentScriptLink = ({ style }) => (
  <div className="consent-document">
    <a
      id="view-verbal-consent-link"
      role="link"
      style={style}
      href={env.VERBAL_CONSENT_SCRIPT_URL}
      target="_blank"
      rel="noreferrer noopener"
    >
      View Verbal Consent Script
    </a>
  </div>
);

ViewVerbalConsentScriptLink.propTypes = {
  style: PropTypes.object.isRequired,
};

ViewVerbalConsentScriptLink.defaultProps = {
  style: {
    color: 'dark-grey',
    textDecoration: 'underline',
    fontSize: '14px',
  },
};

export default ViewVerbalConsentScriptLink;
